import React, { useState, useRef } from "react";
import { PDFDownloadLink, PDFViewer, pdf } from "@react-pdf/renderer";
import {
  FaRegCheckCircle,
  FaUser,
  FaBriefcase,
  FaClock,
  FaHistory,
  FaShieldAlt,
  FaMoneyCheckAlt,
  FaFileSignature,
  FaEye,
  FaArrowLeft,
  FaArrowRight,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaBuilding,
  FaSchool,
  FaUserFriends,
  FaFileAlt,
  FaIdCard,
  FaClipboardCheck,
  FaHeartbeat,
  FaSpinner,
} from "react-icons/fa";
import SignaturePad from "react-signature-canvas";
import PCAApplicationPDF from "./PCACompleteForm";
import { toast } from "react-toastify";
import axios from "axios";
import { CircleCheck } from "lucide-react";
import { createEmploymentApplication, updateEmploymentApplication, submitEmploymentApplication } from "../services/Queries/SupabaseQueries";

export default function PCAApplicationForm() {
  const [currentStep, setCurrentStep] = useState(0);
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(false);
  const [info, setinfo] = useState(false);
  const [message, setMessage] = useState("");
  const [submitError, setSubmitError] = useState(null);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [formData, setFormData] = useState({
    // Cover sheet
    employeeName: "",
    dob: "",
    gender: "",
    address: "",
    employeePhone: "",
    email: "",
    currentlyWorkingPCA: "",
    currentHoursPerWeek: "",
    // Client assigned
    clientName: "",
    clientDOB: "",
    clientGender: "",
    clientAddress: "",
    clientCity: "",
    clientState: "MN",
    clientZip: "",
    clientPhone: "",
    clientInsurance: "",
    additionalInfo: "",

    // Application for Employment
    lastName: "",
    firstName: "",
    middleInitial: "",
    ssn: "",
    streetAddress: "",
    cityStateZip: "",
    phoneNumber: "",
    legalEligibility: "",
    positionDesired: "",
    wageSalaryDesired: "",
    employmentType: "",
    startDate: "",
    age: "",

    // Education & Skills
    enrolledInSchool: "",
    schoolDetails: "",
    jobSkills: "",

    // Availability
    mondayFrom: "",
    mondayTo: "",
    tuesdayFrom: "",
    tuesdayTo: "",
    wednesdayFrom: "",
    wednesdayTo: "",
    thursdayFrom: "",
    thursdayTo: "",
    fridayFrom: "",
    fridayTo: "",
    saturdayFrom: "",
    saturdayTo: "",
    sundayFrom: "",
    sundayTo: "",
    availableHoursPerWeek: "",
    specialRequests: "",

    // References
    ref1Name: "",
    ref1Occupation: "",
    ref1Relationship: "",
    ref1Phone: "",
    ref1HowLong: "",
    ref2Name: "",
    ref2Occupation: "",
    ref2Relationship: "",
    ref2Phone: "",
    ref2HowLong: "",

    // Employment history
    employer1Name: "",
    employer1Title: "",
    employer1Address: "",
    employer1City: "",
    employer1Phone: "",
    employer1DateFrom: "",
    employer1DateTo: "",
    employer1Supervisor: "",
    employer1Reason: "",

    employer2Name: "",
    employer2Title: "",
    employer2Address: "",
    employer2City: "",
    employer2Phone: "",
    employer2DateFrom: "",
    employer2DateTo: "",
    employer2Supervisor: "",
    employer2Reason: "",

    // Criminal history
    fullLegalName: "",
    dobCriminal: "",
     disclosureSSN: "",
    employeeAddressCriminal: "",
    placeOfBirth: "",
    emailCriminal: "",
    convictedFelony: "",
    felonyDetails: "",
    criminalHistory: "",
    criminalDetails: "",

    // Direct deposit
    ddFirstName: "",
    ddMiddleName: "",
    ddLastName: "",
    ddDOB: "",
    ddLastFourSSN: "",
    ddAddress: "",
    ddCityState: "",
    ddZipCode: "",
    ddPhoneNumber: "",
    ddEmail: "",
    ddAccount: "",
    bankName: "",
    bankAccount: "",
    bankRouting: "",

    mecParticipation: "",
    mecCoverageLevel: "Single",
    mecDependents: "",

    // Job description acknowledgement checkbox
    acknowledgesDuties: false,

    // I9-ish fields
    i9CitizenStatus: "",
    i9AlienNumber: "",
    comments: "",

    //signs
    applicantSignature: null,
    caregiverSignature: null,
    hrSignature: null,

    //w-4 form
    w4FirstName: "",
    w4LastName: "",
    w4Address: "",
    w4City: "",
    w4State: "",
    w4Zip: "",
    w4SSN: "",
    w4FilingStatus: "",
    w4MultipleJobs: false,
    w4SpouseWorks: false,
    w4DependentsUnder17: "",
    w4OtherDependents: "",
    w4OtherIncome: "",
    w4Deductions: "",
    w4ExtraWithholding: "",
    w4Signature: "",
    w4Date: "",

    // I-9 Employment Eligibility Verification
    i9LastName: "",
    i9FirstName: "",
    i9MiddleInitial: "",
    i9OtherNames: "",
    i9Address: "",
    i9AptNumber: "",
    i9City: "",
    i9State: "",
    i9Zip: "",
    i9DOB: "",
    i9SSN: "",
    i9Email: "",
    i9Phone: "",
    i9CitizenStatus: "",
    i9AlienNumber: "",
    i9AdmissionNumber: "",
    i9ForeignPassportNumber: "",
    i9CountryOfIssuance: "",
    i9Signature: "",
    i9Date: "",

    i9ListADocument: "",
i9ListADocumentNumber: "",
i9ListAExpirationDate: "",
i9ListBDocument: "",
i9ListBDocumentNumber: "",
i9ListCDocument: "",
i9ListCDocumentNumber: "",
i9AlternativeProcedure: false,
i9EmployerName: "",
i9EmployerAddress: "",
i9FirstDayOfEmployment: "",
i9EmployerDate: "",
i9EmployerTitle: "",
// Section 3 - Reverification
i9NewExpirationDate: "",
i9ReverifyDocumentTitle: "",
i9ReverifyDocumentNumber: "",
i9ReverifySignature: "",
i9ReverifyDate: "",
    // Flyte Training / Acknowledgment Form
    flyteFirstName: "",
    flyteMiddleInitial: "",
    flyteLastName: "",
    flyteSSN: "",
    flyteAddress: "",
    flyteCity: "",
    flyteState: "",
    flyteZip: "",
    flyteCompanyName: "",
    flyteMemberEmail: "",
    flyteCoverageLevel: "",
    flyteEnrollmentType: "",
    flyteHireDate: "",
    flyteEffectiveDate: "",
    flyteWaiver: false,
    flyteSignature: "",
    flyteDate: "",
    // Covered Individuals
    flyteCoveredName0: "",
    flyteCoveredSSN0: "",
    flyteCoveredDOB0: "",
    flyteCoveredGender0: "",
    flyteCoveredRelationship0: "",
    flyteCoveredCarrier0: "",
    flyteCoveredName1: "",
    flyteCoveredSSN1: "",
    flyteCoveredDOB1: "",
    flyteCoveredGender1: "",
    flyteCoveredRelationship1: "",
    flyteCoveredCarrier1: "",
    flyteCoveredName2: "",
    flyteCoveredSSN2: "",
    flyteCoveredDOB2: "",
    flyteCoveredGender2: "",
    flyteCoveredRelationship2: "",
    flyteCoveredCarrier2: "",
    flyteCoveredName3: "",
    flyteCoveredSSN3: "",
    flyteCoveredDOB3: "",
    flyteCoveredGender3: "",
    flyteCoveredRelationship3: "",
    flyteCoveredCarrier3: "",
    // Add this field to your formData state
finalAcknowledgement: false,
  });

  // refs for signature pads
  const applicantSigRef = useRef(null);
  const caregiverSigRef = useRef(null);
  const hrSigRef = useRef(null);

  const steps = [
    { name: "Cover Sheet", icon: FaUser },
    { name: "Employment", icon: FaBriefcase },
    { name: "Availability", icon: FaClock },
    { name: "References", icon: FaUserFriends },
    { name: "Employment History", icon: FaHistory },
    { name: "Background Check", icon: FaShieldAlt },
    { name: "Direct Deposit", icon: FaMoneyCheckAlt },
    { name: "Job Description", icon: FaFileSignature },
    { name: "Signatures", icon: FaFileSignature },
    {
      name: "W-4 Form",
      icon: FaFileAlt,
    },
    {
      name: "I-9 Form",
      icon: FaIdCard,
    },
    {
      name: "Flyte MEC Form",
      icon: FaHeartbeat,
    },
    { name: "Review", icon: FaEye },
  ];

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const nextStep = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep((s) => s + 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep((s) => s - 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const validateCurrentStep = () => {
    let isValid = true;
    let errorMessage = "";

    switch (currentStep) {
      case 0:
        if (
          !formData.employeeName ||
          !formData.employeePhone ||
          !formData.address
        ) {
          errorMessage = "Please fill in employee name, phone and address.";
          isValid = false;
        }
        break;
      case 1:
        if (!formData.lastName || !formData.firstName || !formData.ssn) {
          errorMessage = "Please fill last name, first name, and SSN.";
          isValid = false;
        }
        break;
      case 6:
        if (
          !formData.bankName ||
          !formData.bankAccount ||
          !formData.bankRouting
        ) {
          errorMessage =
            "Please fill bank name, account, and routing for Direct Deposit.";
          isValid = false;
        }
        break;
      default:
        isValid = true;
    }

    if (!isValid) {
      setMessage(errorMessage);
      return false;
    }

    setMessage("");
    return true;
  };

  const handleNext = () => {
    if (validateCurrentStep()) {
      nextStep();
    }
  };

  const clearSig = (ref) => {
    if (ref.current) ref.current.clear();
  };
  const getSigDataURL = (ref) => {
    if (!ref?.current) return null;
    try {
      if (typeof ref.current.isEmpty === "function" && !ref.current.isEmpty()) {
        const data = ref.current.getCanvas().toDataURL("image/png");
        console.log("✅ Signature captured:", data.substring(0, 50) + "...");
        return data;
      } else {
        console.warn("⚠️ Signature pad is empty");
        return null;
      }
    } catch (error) {
      console.error("Error getting signature:", error);
      return null;
    }
  };
const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  setSubmitError(null);
  
  // === Signature & Validation ===
  let applicantSig = formData.applicantSignature;
  let caregiverSig = formData.caregiverSignature;

  if (!applicantSig) {
    setMessage("Please provide applicant signature before submitting.");
    setCurrentStep(8);
    setLoading(false);
    return;
  }
  if (!caregiverSig) {
    setMessage("Please provide caregiver signature before submitting.");
    setCurrentStep(8);
    setLoading(false);
    return;
  }
  const hrSig = formData.hrSignature;
  if (!formData.finalAcknowledgement) {
    setMessage("Please acknowledge that you have read the job description.");
    setCurrentStep(12);
    setLoading(false);
    return;
  }

  // Update form data with signatures
  const updatedFormData = {
    ...formData,
    applicantSignature: applicantSig,
    caregiverSignature: caregiverSig,
    hrSignature: hrSig,
    submittedAt: new Date().toISOString(),
  };

  setFormData(updatedFormData);
  console.log('Submitting form data:', updatedFormData);
  
  try {
    // Save to database and send HR notification
    const result = await submitEmploymentApplication(updatedFormData);
    
    console.log('Supabase response:', result);
    
    // Check if we got a valid response (has an id)
    if (result && result.id) {
      setSubmitSuccess(true);
      setSaved(true);
      setMessage("Application saved to database successfully!");
      toast.success("Application submitted successfully!");
      
    } else {
      // Handle API error response
      const errorMsg = result?.error || 'Failed to save application';
      setSubmitError(errorMsg);
      toast.error("Failed to save application: " + errorMsg);
      setMessage(" " + errorMsg);
    }
  } catch (error) {
    console.error("Submit error:", error);
    setSubmitError(error.message);
    toast.error("An error occurred while submitting: " + error.message);
    setMessage(" " + error.message);
  } finally {
    setLoading(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
};

  // Render Components
  const renderCoverSheet = () => (
    <div className="space-y-8">
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-6 rounded-xl border border-blue-100">
        <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-3">
          <FaUser className="text-blue-600" />
          Information Cover Sheet
        </h2>
        <p className="text-gray-600 mt-2">
          Basic information about the employee and assigned client
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
          <h3 className="text-lg font-semibold text-gray-800 mb-4 pb-2 border-b">
            Employee Information
          </h3>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Employee Name
              </label>
              <input
                name="employeeName"
                value={formData.employeeName}
                onChange={handleInputChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                placeholder="Full name"
              />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Date of Birth
                </label>
                <input
                  type="date"
                  name="dob"
                  value={formData.dob}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Gender
                </label>
                <select
                  name="gender"
                  value={formData.gender}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="">Select</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Address
              </label>
              <input
                name="address"
                value={formData.address}
                onChange={handleInputChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Street, city, state"
              />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <FaPhone className="inline mr-2 text-gray-400" />
                  Phone
                </label>
                <input
                  name="employeePhone"
                  value={formData.employeePhone}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="+1 (555) 555-5555"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <FaEnvelope className="inline mr-2 text-gray-400" />
                  Email
                </label>
                <input
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="email@example.com"
                />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Currently working as PCA/CFSS?
                </label>
                <select
                  name="currentlyWorkingPCA"
                  value={formData.currentlyWorkingPCA}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Current Hours/Week
                </label>
                <input
                  type="number"
                  name="currentHoursPerWeek"
                  value={formData.currentHoursPerWeek}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="e.g., 20"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
          <h3 className="text-lg font-semibold text-gray-800 mb-4 pb-2 border-b">
            Assigned Client Information
          </h3>
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Client Name
                </label>
                <input
                  name="clientName"
                  value={formData.clientName}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Client DOB
                </label>
                <input
                  type="date"
                  name="clientDOB"
                  value={formData.clientDOB}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                <FaMapMarkerAlt className="inline mr-2 text-gray-400" />
                Client Address
              </label>
              <input
                name="clientAddress"
                value={formData.clientAddress}
                onChange={handleInputChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <div className="grid grid-cols-3 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  City
                </label>
                <input
                  name="clientCity"
                  value={formData.clientCity}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  State
                </label>
                <input
                  value="MN"
                  disabled
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-gray-50 text-gray-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Zip
                </label>
                <input
                  name="clientZip"
                  value={formData.clientZip}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Client Phone Number
              </label>
              <input
                name="clientPhone"
                type="number"
                value={formData.clientPhone}
                onChange={handleInputChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Client Insurance
              </label>
              <input
                name="clientInsurance"
                value={formData.clientInsurance}
                onChange={handleInputChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Additional Information
              </label>
              <textarea
                name="additionalInfo"
                value={formData.additionalInfo}
                onChange={handleInputChange}
                rows={3}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderEmploymentApplication = () => (
    <div className="space-y-8">
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-6 rounded-xl border border-blue-100">
        <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-3">
          <FaBriefcase className="text-blue-600" />
          Application for Employment
        </h2>
        <p className="text-gray-600 mt-2">
          Personal details and employment preferences
        </p>
      </div>

      <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Last Name
            </label>
            <input
              name="lastName"
              value={formData.lastName}
              onChange={handleInputChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              First Name
            </label>
            <input
              name="firstName"
              value={formData.firstName}
              onChange={handleInputChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Middle Initial
            </label>
            <input
              name="middleInitial"
              value={formData.middleInitial}
              onChange={handleInputChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              maxLength={1}
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Social Security #
            </label>
            <input
              name="ssn"
              value={formData.ssn}
              onChange={handleInputChange}
              placeholder="XXX-XX-XXXX"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <FaPhone className="inline mr-2 text-gray-400" />
              Phone Number
            </label>
            <input
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={handleInputChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
        </div>

        <div className="mt-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            <FaMapMarkerAlt className="inline mr-2 text-gray-400" />
            Street Address
          </label>
          <input
            name="streetAddress"
            value={formData.streetAddress}
            onChange={handleInputChange}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Legal eligibility to work in U.S.?
            </label>
            <select
              name="legalEligibility"
              value={formData.legalEligibility}
              onChange={handleInputChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <option value="">Select</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Position Desired
            </label>
            <input
              name="positionDesired"
              value={formData.positionDesired}
              onChange={handleInputChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Wage/Salary Desired
            </label>
            <input
              name="wageSalaryDesired"
              value={formData.wageSalaryDesired}
              onChange={handleInputChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Start Date
            </label>
            <input
              type="date"
              name="startDate"
              value={formData.startDate}
              onChange={handleInputChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Age
            </label>
            <input
              name="age"
              type="number"
              value={formData.age}
              onChange={handleInputChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
        </div>

        <div className="mt-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Employment Type
          </label>
          <div className="flex gap-6">
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="employmentType"
                value="Part Time"
                checked={formData.employmentType === "Part Time"}
                onChange={handleInputChange}
                className="w-4 h-4 text-blue-600 focus:ring-blue-500"
              />
              <span className="text-gray-700">Part Time</span>
            </label>
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="employmentType"
                value="Full Time"
                checked={formData.employmentType === "Full Time"}
                onChange={handleInputChange}
                className="w-4 h-4 text-blue-600 focus:ring-blue-500"
              />
              <span className="text-gray-700">Full Time</span>
            </label>
          </div>
        </div>

        {/* Education Section */}
        <div className="mt-8 pt-6 border-t">
          <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
            <FaSchool className="text-blue-600" />
            Education & Skills
          </h3>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Are you presently enrolled in school?
              </label>
              <select
                name="enrolledInSchool"
                value={formData.enrolledInSchool}
                onChange={handleInputChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              >
                <option value="">Select</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>
            {formData.enrolledInSchool === "Yes" && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  School details
                </label>
                <textarea
                  name="schoolDetails"
                  value={formData.schoolDetails}
                  onChange={handleInputChange}
                  rows={3}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="School name, address & expected degree date"
                />
              </div>
            )}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Job-related skills or accomplishments
              </label>
              <textarea
                name="jobSkills"
                value={formData.jobSkills}
                onChange={handleInputChange}
                rows={3}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderAvailability = () => (
    <div className="space-y-8">
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-6 rounded-xl border border-blue-100">
        <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-3">
          <FaClock className="text-blue-600" />
          Availability Schedule
        </h2>
        <p className="text-gray-600 mt-2">
          Specify your available days and times
        </p>
      </div>

      <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[
            { day: "Monday", from: "mondayFrom", to: "mondayTo" },
            { day: "Tuesday", from: "tuesdayFrom", to: "tuesdayTo" },
            { day: "Wednesday", from: "wednesdayFrom", to: "wednesdayTo" },
            { day: "Thursday", from: "thursdayFrom", to: "thursdayTo" },
            { day: "Friday", from: "fridayFrom", to: "fridayTo" },
            { day: "Saturday", from: "saturdayFrom", to: "saturdayTo" },
            { day: "Sunday", from: "sundayFrom", to: "sundayTo" },
          ].map(({ day, from, to }) => (
            <div key={day} className="bg-gray-50 p-4 rounded-lg">
              <h4 className="font-semibold text-gray-800 mb-3">{day}</h4>
              <div className="space-y-3">
                <div>
                  <label className="block text-sm text-gray-600 mb-1">
                    From
                  </label>
                  <input
                    type="time"
                    name={from}
                    value={formData[from]}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label className="block text-sm text-gray-600 mb-1">To</label>
                  <input
                    type="time"
                    name={to}
                    value={formData[to]}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Available hours per week
            </label>
            <input
              type="number"
              name="availableHoursPerWeek"
              value={formData.availableHoursPerWeek}
              onChange={handleInputChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Special requests/needs
            </label>
            <input
              name="specialRequests"
              value={formData.specialRequests}
              onChange={handleInputChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
        </div>
      </div>
    </div>
  );

  const renderReferences = () => (
    <div className="space-y-8">
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-6 rounded-xl border border-blue-100">
        <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-3">
          <FaUserFriends className="text-blue-600" />
          Professional References
        </h2>
        <p className="text-gray-600 mt-2">
          Provide two professional references (not related)
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {[1, 2].map((num) => (
          <div
            key={num}
            className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm"
          >
            <h3 className="text-lg font-semibold text-gray-800 mb-4">
              Reference {num}
            </h3>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Full Name
                </label>
                <input
                  name={`ref${num}Name`}
                  value={formData[`ref${num}Name`]}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Occupation
                </label>
                <input
                  name={`ref${num}Occupation`}
                  value={formData[`ref${num}Occupation`]}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Relationship & How Long
                </label>
                <input
                  name={`ref${num}HowLong`}
                  value={formData[`ref${num}HowLong`]}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <FaPhone className="inline mr-2 text-gray-400" />
                  Phone Number
                </label>
                <input
                  name={`ref${num}Phone`}
                  value={formData[`ref${num}Phone`]}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  const renderEmploymentHistory = () => (
    <div className="space-y-8">
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-6 rounded-xl border border-blue-100">
        <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-3">
          <FaHistory className="text-blue-600" />
          Employment History
        </h2>
        <p className="text-gray-600 mt-2">
          List your previous employment experiences
        </p>
      </div>

      <div className="space-y-6">
        {[1, 2].map((num) => (
          <div
            key={num}
            className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm"
          >
            <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
              <FaBuilding className="text-blue-600" />
              Employer {num}
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Employer Name
                </label>
                <input
                  name={`employer${num}Name`}
                  value={formData[`employer${num}Name`]}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Job Title
                </label>
                <input
                  name={`employer${num}Title`}
                  value={formData[`employer${num}Title`]}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Address
                </label>
                <input
                  name={`employer${num}Address`}
                  value={formData[`employer${num}Address`]}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  City/State/Zip
                </label>
                <input
                  name={`employer${num}City`}
                  value={formData[`employer${num}City`]}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Phone
                </label>
                <input
                  name={`employer${num}Phone`}
                  value={formData[`employer${num}Phone`]}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Employment Dates (From)
                </label>
                <input
                  type="date"
                  name={`employer${num}DateFrom`}
                  value={formData[`employer${num}DateFrom`]}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Employment Dates (To)
                </label>
                <input
                  type="date"
                  name={`employer${num}DateTo`}
                  value={formData[`employer${num}DateTo`]}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Supervisor
                </label>
                <input
                  name={`employer${num}Supervisor`}
                  value={formData[`employer${num}Supervisor`]}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Reason for Leaving
                </label>
                <input
                  name={`employer${num}Reason`}
                  value={formData[`employer${num}Reason`]}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  const renderBackgroundCheck = () => (
    <div className="space-y-8">
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-6 rounded-xl border border-blue-100">
        <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-3">
          <FaShieldAlt className="text-blue-600" />
          Criminal Background Disclosure
        </h2>
        <p className="text-gray-600 mt-2">
          Required background information for employment
        </p>
      </div>

      <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Full Legal Name
            </label>
            <input
              name="fullLegalName"
              value={formData.fullLegalName}
              onChange={handleInputChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Date of Birth
            </label>
            <input
              type="date"
              name="dobCriminal"
              value={formData.dobCriminal}
              onChange={handleInputChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
            <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              SSN number 
              </label>
               <input
              name="disclosureSSN"
              value={formData.disclosureSSN}
              onChange={handleInputChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <div >
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Address
            </label>
            <input
              name="employeeAddressCriminal"
              value={formData.employeeAddressCriminal}
              onChange={handleInputChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Place of Birth (Country)
            </label>
            <input
              name="placeOfBirth"
              value={formData.placeOfBirth}
              onChange={handleInputChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Email
            </label>
            <input
              name="emailCriminal"
              value={formData.emailCriminal}
              onChange={handleInputChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
        </div>

        <div className="mt-6 space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Have you been convicted of a felony?
            </label>
            <select
              name="convictedFelony"
              value={formData.convictedFelony}
              onChange={handleInputChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <option value="">Select</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </div>

          {formData.convictedFelony === "Yes" && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Felony Details
              </label>
              <textarea
                name="felonyDetails"
                value={formData.felonyDetails}
                onChange={handleInputChange}
                rows={4}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Please provide details about the felony conviction..."
              />
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Do you have any other criminal history?
            </label>
            <select
              name="criminalHistory"
              value={formData.criminalHistory}
              onChange={handleInputChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <option value="">Select</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </div>

          {formData.criminalHistory === "Yes" && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Criminal History Details
              </label>
              <textarea
                name="criminalDetails"
                value={formData.criminalDetails}
                onChange={handleInputChange}
                rows={4}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Please provide details about your criminal history..."
              />
            </div>
          )}
        </div>

        <div className="mt-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
          <p className="text-sm text-blue-700">
            <strong>Authorization:</strong> By signing this form, you authorize
            SAMAH to submit fingerprint/background study to DHS as required by
            law.
          </p>
        </div>
      </div>
    </div>
  );

  const renderDirectDeposit = () => (
    <div className="space-y-8">
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-6 rounded-xl border border-blue-100">
        <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-3">
          <FaMoneyCheckAlt className="text-blue-600" />
          Direct Deposit Information
        </h2>
        <p className="text-gray-600 mt-2">
          Set up your direct deposit for payroll
        </p>
      </div>

      <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              First Name
            </label>
            <input
              name="ddFirstName"
              value={formData.ddFirstName}
              onChange={handleInputChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Middle Name
            </label>
            <input
              name="ddMiddleName"
              value={formData.ddMiddleName}
              onChange={handleInputChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Last Name
            </label>
            <input
              name="ddLastName"
              value={formData.ddLastName}
              onChange={handleInputChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Date of Birth
            </label>
            <input
              type="date"
              name="ddDOB"
              value={formData.ddDOB}
              onChange={handleInputChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Last 4 Digits of SSN
            </label>
            <input
              name="ddLastFourSSN"
              value={formData.ddLastFourSSN}
              onChange={handleInputChange}
              maxLength={4}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
        </div>

        <div className="mt-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Address
          </label>
          <input
            name="ddAddress"
            value={formData.ddAddress}
            onChange={handleInputChange}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              City/State
            </label>
            <input
              name="ddCityState"
              value={formData.ddCityState}
              onChange={handleInputChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Zip Code
            </label>
            <input
              name="ddZipCode"
              value={formData.ddZipCode}
              onChange={handleInputChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Phone Number
            </label>
            <input
              name="ddPhoneNumber"
              value={formData.ddPhoneNumber}
              onChange={handleInputChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
        </div>

        <div className="mt-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Email
          </label>
          <input
            name="ddEmail"
            value={formData.ddEmail}
            onChange={handleInputChange}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>

        <div className="mt-8 pt-6 border-t">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">
            Bank Information
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Bank Name
              </label>
              <input
                name="bankName"
                value={formData.bankName}
                onChange={handleInputChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Account Number
              </label>
              <input
                name="bankAccount"
                value={formData.bankAccount}
                onChange={handleInputChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Routing Number
              </label>
              <input
                name="bankRouting"
                value={formData.bankRouting}
                onChange={handleInputChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
          </div>
        </div>

        <div className="sm:w-[300px] lg:w-[400px] px-8 py-8 bg-blue-400 flex flex-col gap-5 rounded-lg shadow-[0px_0px_20px_rgba(0,0,0,0.3)] mt-6">
          <legend className="text-xl font-bold mb-2 text-white select-none">
            Bank Account Status
          </legend>

          {/* === CURRENT ACCOUNT === */}
          <label
            htmlFor="current"
            className="font-medium h-16 relative hover:bg-gray-700 transition-all duration-300 flex items-center px-5 gap-3 rounded-lg 
    has-[:checked]:text-blue-400 has-[:checked]:bg-gray-700 has-[:checked]:ring-blue-500 has-[:checked]:ring-2 
    select-none cursor-pointer"
          >
            <div className="w-5 fill-current text-white">
              {/* 🏦 bank icon */}
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path
                  d="M12 2 1 7v2h22V7L12 2zm1 7h7v10h-7V9zm-9 0h7v10H4V9zm17 11H3v2h18v-2z"
                />
              </svg>
            </div>
            <span className="text-white">Checking Account</span>

            <input
              type="radio"
              id="current"
              name="ddAccount"
              value="Checking"
              onChange={handleInputChange}
              className="peer/current w-4 h-4 absolute accent-blue-400 right-5 transition-all duration-300"
            />

            <span className="absolute right-5 w-4 h-4 rounded-full border-2 border-gray-400 
      peer-checked/current:border-blue-400 peer-checked/current:bg-blue-400 
      transition-all duration-300"></span>
          </label>

          {/* === SAVINGS ACCOUNT === */}
          <label
            htmlFor="saving"
            className="font-medium h-16 relative hover:bg-gray-700 transition-all duration-300 flex items-center px-5 gap-3 rounded-lg 
    has-[:checked]:text-blue-400 has-[:checked]:bg-gray-700 has-[:checked]:ring-blue-500 has-[:checked]:ring-2 
    select-none cursor-pointer"
          >
            <div className="w-5 fill-current text-white">
              {/* 💰 saving icon */}
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path
                  d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 
          10-10S17.52 2 12 2zm1 17.93c-3.95.49-7.43-2.54-7.92-6.49A8 8 0 
          0113 4.07v1.9c-2.83.48-4.89 3.05-4.41 5.88.4 2.32 2.41 4.07 
          4.79 4.07h.62v2.91z"
                />
              </svg>
            </div>
            <span className="text-white">Saving Account</span>

            <input
              type="radio"
              id="saving"
              name="ddAccount"
              value="saving"
              onChange={handleInputChange}
              className="peer/saving w-4 h-4 absolute accent-blue-400 right-5 transition-all duration-300"
            />

            <span className="absolute right-5 w-4 h-4 rounded-full border-2 border-gray-400 
      peer-checked/saving:border-blue-400 peer-checked/saving:bg-blue-400 
      transition-all duration-300"></span>
          </label>
        </div>

        {/* {
          formData.ddAccount && (
            <p>
              {formData.ddAccount === 'current' ? 'You have selected Current Account for direct deposit.' : 'You have selected Saving Account for direct deposit.'}
            </p>
          )
        } */}

        <div className="mt-6 p-4 bg-green-50 rounded-lg border border-green-200">
          <p className="text-sm text-green-700">
            <strong>Authorization:</strong> By signing below, you authorize
            direct deposit of your payroll to the bank account provided above.
          </p>
        </div>

      </div>
    </div>
  );

  const renderJobDescription = () => (
    <div className="space-y-8">
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-6 rounded-xl border border-blue-100">
        <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-3">
          <FaFileSignature className="text-blue-600" />
          PCA Job Description & Duties
        </h2>
        <p className="text-gray-600 mt-2">
          Review and acknowledge the PCA responsibilities
        </p>
      </div>

      <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
        <div className="prose max-w-none">
          <h3 className="text-xl font-semibold text-gray-800 mb-4">
            Personal Care Assistant (PCA) Duties
          </h3>
          <div className="bg-blue-50 p-4 rounded-lg mb-6">
            <p className="text-blue-800 text-sm">
              As a PCA, you will be responsible for providing essential care and
              support to clients in their homes. Below are the primary duties
              and responsibilities:
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-blue-600 text-sm font-semibold">1</span>
                </div>
                <p className="text-gray-700">
                  Assist with toileting and incontinence care
                </p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-blue-600 text-sm font-semibold">2</span>
                </div>
                <p className="text-gray-700">
                  Skin care and pressure sore prevention
                </p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-blue-600 text-sm font-semibold">3</span>
                </div>
                <p className="text-gray-700">
                  Range of motion and muscle strengthening exercises
                </p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-blue-600 text-sm font-semibold">4</span>
                </div>
                <p className="text-gray-700">
                  Transfers and ambulation assistance
                </p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-blue-600 text-sm font-semibold">5</span>
                </div>
                <p className="text-gray-700">
                  Bathing, grooming, and hair washing
                </p>
              </div>
            </div>

            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-blue-600 text-sm font-semibold">6</span>
                </div>
                <p className="text-gray-700">Turning and positioning in bed</p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-blue-600 text-sm font-semibold">7</span>
                </div>
                <p className="text-gray-700">
                  Medication reminders per RN care plan
                </p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-blue-600 text-sm font-semibold">8</span>
                </div>
                <p className="text-gray-700">
                  Dressing and undressing assistance
                </p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-blue-600 text-sm font-semibold">9</span>
                </div>
                <p className="text-gray-700">
                  Eating assistance and meal preparation
                </p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-blue-600 text-sm font-semibold">
                    10
                  </span>
                </div>
                <p className="text-gray-700">
                  Accompanying to medical appointments
                </p>
              </div>
            </div>
          </div>

          <div className="mt-8 p-4 bg-yellow-50 rounded-lg border border-yellow-200">
            <h4 className="font-semibold text-yellow-800 mb-2">
              Orientation & Training
            </h4>
            <p className="text-yellow-700 text-sm">
              All PCAs must complete orientation training covering client
              rights, safety procedures, emergency protocols, and specific care
              techniques. Ongoing training will be provided as needed.
            </p>
          </div>

          <div className="mt-6">
            <label className="flex items-start gap-3">
              <input
                type="checkbox"
                name="acknowledgesDuties"
                checked={formData.acknowledgesDuties}
                onChange={handleInputChange}
                className="w-5 h-5 text-blue-600 focus:ring-blue-500 mt-1 flex-shrink-0"
              />
              <span className="text-gray-700">
                I have read, understand, and agree to perform the duties and
                responsibilities outlined above. I acknowledge that I will
                receive proper training and orientation for these tasks.
              </span>
            </label>
          </div>
        </div>
      </div>
    </div>
  );

  const renderSignatures = () => (
    <div className="space-y-8">
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-6 rounded-xl border border-blue-100">
        <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-3">
          <FaFileSignature className="text-blue-600" />
          Digital Signatures
        </h2>
        <p className="text-gray-600 mt-2">
          Provide the applicant and caregiver signatures before submission. HR signature is optional.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">
            Applicant Signature
          </h3>
          <p className="text-sm text-gray-600 mb-4">
            Sign in the box below using your mouse or touchscreen
          </p>
          <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 bg-gray-50 min-h-[200px]">
            <SignaturePad
              ref={applicantSigRef}
              canvasProps={{
                className: "w-full h-48 bg-white rounded signature-pad",
                width: 500,
                height: 200,
              }}
            />
          </div>
          <div className="flex gap-3 mt-4">
            <button
              type="button"
              onClick={() => clearSig(applicantSigRef)}
              className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors flex-1"
            >
              Clear Signature
            </button>
            <button
              type="button"
              onClick={() => {
                const sig = getSigDataURL(applicantSigRef);

                if (sig) {
                  setFormData({ ...formData, applicantSignature: sig });
                  alert("Applicant signature saved successfully!");
                } else {
                  setMessage("Please provide your signature first.");
                }
              }}
              className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors flex-1"
            >
              Save Signature
            </button>
          </div>
        </div>

        <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">
            Caregiver Signature
          </h3>
          <p className="text-sm text-gray-600 mb-4">
            Required if client is able to provide consent
          </p>
          <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 bg-gray-50 min-h-[200px]">
            <SignaturePad
              ref={caregiverSigRef}
              canvasProps={{
                className: "w-full h-48 bg-white rounded signature-pad Signpad",
                width: 500,
                height: 200,
              }}
            />
          </div>
          <div className="flex gap-3 mt-4">
            <button
              type="button"
              onClick={() => clearSig(caregiverSigRef)}
              className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors flex-1"
            >
              Clear Signature
            </button>
            <button
              type="button"
              onClick={() => {
                const sig = getSigDataURL(caregiverSigRef);
                if (sig) {
                  setFormData({ ...formData, caregiverSignature: sig });
                  alert("Caregiver signature saved successfully!");
                } else {
                  setMessage("Please provide caregiver signature first.");
                }
              }}
              className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors flex-1"
            >
              Save Signature
            </button>
          </div>
        </div>
      </div>
      <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">
          HR/Payroll Signature (Optional)
        </h3>
        <p className="text-sm text-gray-600 mb-4">
          For internal use by SAMAH staff
        </p>
        <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 bg-gray-50 max-w-[390px] min-h-[200px]">
          <SignaturePad
            ref={hrSigRef}
            canvasProps={{
              className: " h-48 bg-white rounded signature-pad Signpad",
              width: 800,
              height: 200,
            }}
          />
        </div>
        <div className="flex gap-3 mt-4">
          <button
            type="button"
            onClick={() => clearSig(hrSigRef)}
            className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors flex-1"
          >
            Clear Signature
          </button>
          <button
            type="button"
            onClick={() => {
              const sig = getSigDataURL(hrSigRef);
              if (sig) {
                setFormData({ ...formData, hrSignature: sig });
                alert("HR signature saved successfully!");
              } else {
                setMessage("Please provide HR signature first.");
              }
            }}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex-1"
          >
            Save HR Signature
          </button>
        </div>
      </div>
    </div>
  );

  const renderReview = () => (
    <div className="space-y-8">
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-6 rounded-xl border border-blue-100">
        <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-3">
          <FaEye className="text-blue-600" />
          Review & Submit Application
        </h2>
        <p className="text-gray-600 mt-2">
          Review all information before final submission
        </p>
      </div>

      <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
        <div className="space-y-6">
          {/* Personal Information */}
          <div className="border-b pb-6">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">
              Personal Information
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="text-sm font-medium text-gray-600">
                  Full Name
                </label>
                <p className="text-gray-800">
                  {formData.employeeName || "Not provided"}
                </p>
              </div>
              <div>
                <label className="text-sm font-medium text-gray-600">
                  Date of Birth
                </label>
                <p className="text-gray-800">
                  {formData.dob || "Not provided"}
                </p>
              </div>
              <div>
                <label className="text-sm font-medium text-gray-600">
                  Phone
                </label>
                <p className="text-gray-800">
                  {formData.employeePhone || "Not provided"}
                </p>
              </div>
              <div>
                <label className="text-sm font-medium text-gray-600">
                  Email
                </label>
                <p className="text-gray-800">
                  {formData.email || "Not provided"}
                </p>
              </div>
              <div className="md:col-span-2">
                <label className="text-sm font-medium text-gray-600">
                  Address
                </label>
                <p className="text-gray-800">
                  {formData.address || "Not provided"}
                </p>
              </div>
            </div>
          </div>

          {/* Employment Information */}
          <div className="border-b pb-6">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">
              Employment Information
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="text-sm font-medium text-gray-600">
                  Position
                </label>
                <p className="text-gray-800">
                  {formData.positionDesired || "Not provided"}
                </p>
              </div>
              <div>
                <label className="text-sm font-medium text-gray-600">
                  Employment Type
                </label>
                <p className="text-gray-800">
                  {formData.employmentType || "Not provided"}
                </p>
              </div>
              <div>
                <label className="text-sm font-medium text-gray-600">
                  Desired Wage
                </label>
                <p className="text-gray-800">
                  {formData.wageSalaryDesired || "Not provided"}
                </p>
              </div>
              <div>
                <label className="text-sm font-medium text-gray-600">
                  Start Date
                </label>
                <p className="text-gray-800">
                  {formData.startDate || "Not provided"}
                </p>
              </div>
            </div>
          </div>

          {/* Signatures Preview */}
          <div>
            <h3 className="text-xl font-semibold text-gray-800 mb-4">
              Signatures
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <label className="text-sm font-medium text-gray-600 block mb-2">
                  Applicant Signature
                </label>
                <div className="border rounded-lg p-2 h-24 bg-gray-50 flex items-center justify-center">
                  {formData.applicantSignature ? (
                    <img
                      src={formData.applicantSignature}
                      alt="Applicant Signature"
                      className="max-h-20 max-w-full object-contain"
                    />
                  ) : (
                    <span className="text-gray-400 text-sm">Not signed</span>
                  )}
                </div>
              </div>
              <div>
                <label className="text-sm font-medium text-gray-600 block mb-2">
                  Caregiver Signature
                </label>
                <div className="border rounded-lg p-2 h-24 bg-gray-50 flex items-center justify-center">
                  {formData.caregiverSignature ? (
                    <img
                      src={formData.caregiverSignature}
                      alt="Caregiver Signature"
                      className="max-h-20 max-w-full object-contain"
                    />
                  ) : (
                    <span className="text-gray-400 text-sm">Not signed</span>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Final Acknowledgement */}
          <div className="mt-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
            <div className="flex items-start gap-3">
             <input
  type="checkbox"
  id="final-acknowledgement"
  name="finalAcknowledgement"  // Add name attribute
  className="w-5 h-5 text-blue-600 focus:ring-blue-500 mt-1 flex-shrink-0"
  checked={formData.finalAcknowledgement}
  onChange={handleInputChange}  // Use the existing handler
/>
              <label
                htmlFor="final-acknowledgement"
                className="text-sm text-blue-700"
              >
                I certify that all information provided in this application is
                true and complete to the best of my knowledge. I understand that
                any false or misleading information may result in denial of
                employment or termination if discovered after hiring.
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  // W-4 Form

  const renderW4Form = () => (
    <div className="space-y-8">
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-6 rounded-xl border border-blue-100">
        <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-3">
          <FaFileAlt className="text-blue-600" />
          IRS Form W-4 — Employee’s Withholding Certificate
        </h2>
        <p className="text-gray-600 mt-2">
          Provide your tax withholding information as required by the IRS
        </p>
      </div>

      <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
        {/* Step 1: Personal Info */}
        <h3 className="text-lg font-semibold text-gray-800 mb-4">
          Step 1 — Personal Information
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <input
            name="w4FirstName"
            value={formData.w4FirstName}
            onChange={handleInputChange}
            placeholder="First Name"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg"
          />
          <input
            name="w4LastName"
            value={formData.w4LastName}
            onChange={handleInputChange}
            placeholder="Last Name"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg"
          />
          <input
            name="w4Address"
            value={formData.w4Address}
            onChange={handleInputChange}
            placeholder="Address"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg md:col-span-2"
          />
          <input
            name="w4City"
            value={formData.w4City}
            onChange={handleInputChange}
            placeholder="City"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg"
          />
          <input
            name="w4State"
            value={formData.w4State}
            onChange={handleInputChange}
            placeholder="State"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg"
          />
          <input
            name="w4Zip"
            value={formData.w4Zip}
            onChange={handleInputChange}
            placeholder="ZIP Code"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg"
          />
          <input
            name="w4SSN"
            value={formData.w4SSN}
            onChange={handleInputChange}
            placeholder="Social Security Number"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg md:col-span-2"
          />
        </div>

        {/* Step 1b: Filing Status */}
        <div className="mt-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Filing Status
          </label>
          <div className="flex flex-wrap gap-6">
            {["Single", "Married Filing Jointly", "Head of Household"].map(
              (status) => (
                <label key={status} className="flex items-center gap-2">
                  <input
                    type="radio"
                    name="w4FilingStatus"
                    value={status}
                    checked={formData.w4FilingStatus === status}
                    onChange={handleInputChange}
                    className="w-4 h-4 text-blue-600 focus:ring-blue-500"
                  />
                  {status}
                </label>
              )
            )}
          </div>
        </div>

        {/* Step 2: Multiple Jobs / Spouse Works */}
        <div className="mt-8 border-t pt-6">
          <h3 className="text-lg font-semibold text-gray-800 mb-3">
            Step 2 — Multiple Jobs or Spouse Works
          </h3>
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              name="w4MultipleJobs"
              checked={formData.w4MultipleJobs}
              onChange={handleInputChange}
              className="w-5 h-5 text-blue-600"
            />
            I have more than one job
          </label>
          <label className="flex items-center gap-2 mt-2">
            <input
              type="checkbox"
              name="w4SpouseWorks"
              checked={formData.w4SpouseWorks}
              onChange={handleInputChange}
              className="w-5 h-5 text-blue-600"
            />
            My spouse also works
          </label>
        </div>

        {/* Step 3: Claim Dependents */}
        <div className="mt-8 border-t pt-6">
          <h3 className="text-lg font-semibold text-gray-800 mb-3">
            Step 3 — Claim Dependents
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <input
              type="number"
              name="w4DependentsUnder17"
              value={formData.w4DependentsUnder17}
              onChange={handleInputChange}
              placeholder="Dependents under age 17"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg"
            />
            <input
              type="number"
              name="w4OtherDependents"
              value={formData.w4OtherDependents}
              onChange={handleInputChange}
              placeholder="Other dependents"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg"
            />
          </div>
        </div>

        {/* Step 4: Other Adjustments */}
        <div className="mt-8 border-t pt-6">
          <h3 className="text-lg font-semibold text-gray-800 mb-3">
            Step 4 — Other Adjustments (Optional)
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <input
              type="number"
              name="w4OtherIncome"
              value={formData.w4OtherIncome}
              onChange={handleInputChange}
              placeholder="Other income"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg"
            />
            <input
              type="number"
              name="w4Deductions"
              value={formData.w4Deductions}
              onChange={handleInputChange}
              placeholder="Deductions"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg"
            />
            <input
              type="number"
              name="w4ExtraWithholding"
              value={formData.w4ExtraWithholding}
              onChange={handleInputChange}
              placeholder="Extra withholding"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg"
            />
          </div>
        </div>

        {/* Step 5: Signature */}
        <div className="mt-8 border-t pt-6">
          <h3 className="text-lg font-semibold text-gray-800 mb-3">
            Step 5 — Sign Here
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {formData.applicantSignature && (
              <div className="flex flex-col items-center">
                <img
                  src={formData.applicantSignature}
                  alt="Applicant Signature"
                  className="max-h-20 max-w-full object-contain mb-2"
                />
                <span className="text-sm text-gray-600">Signature on file</span>
              </div>
            )}
            <input
              type="date"
              name="w4Date"
              value={formData.w4Date}
              onChange={handleInputChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg"
            />
          </div>
        </div>
      </div>
    </div>
  );

  // I-9 form

  // I-9 form - Complete with Section 2

const renderI9Form = () => (
  <div className="space-y-8">
    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-6 rounded-xl border border-blue-100">
      <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-3">
        <FaIdCard className="text-blue-600" />
        Form I-9 — Employment Eligibility Verification
      </h2>
      <p className="text-gray-600 mt-2">
        Verify your identity and authorization to work in the United States
      </p>
    </div>

    <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
      {/* Section 1 — Employee Info */}
      <div className="border-b pb-6 mb-6">
        <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
          <span className="bg-blue-600 text-white w-6 h-6 rounded-full flex items-center justify-center text-sm">1</span>
          Employee Information and Attestation
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <input
            name="i9LastName"
            value={formData.i9LastName}
            onChange={handleInputChange}
            placeholder="Last Name (Family Name)"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
          />
          <input
            name="i9FirstName"
            value={formData.i9FirstName}
            onChange={handleInputChange}
            placeholder="First Name (Given Name)"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
          />
          <input
            name="i9MiddleInitial"
            value={formData.i9MiddleInitial}
            onChange={handleInputChange}
            placeholder="Middle Initial"
            maxLength={1}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div className="mt-4">
          <input
            name="i9OtherNames"
            value={formData.i9OtherNames}
            onChange={handleInputChange}
            placeholder="Other Last Names Used (if any)"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
          <input
            name="i9Address"
            value={formData.i9Address}
            onChange={handleInputChange}
            placeholder="Address (Street Number and Name)"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
          />
          <input
            name="i9AptNumber"
            value={formData.i9AptNumber}
            onChange={handleInputChange}
            placeholder="Apt. Number (if any)"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mt-4">
          <input
            name="i9City"
            value={formData.i9City}
            onChange={handleInputChange}
            placeholder="City or Town"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
          />
          <input
            name="i9State"
            value={formData.i9State}
            onChange={handleInputChange}
            placeholder="State"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
          />
          <input
            name="i9Zip"
            value={formData.i9Zip}
            onChange={handleInputChange}
            placeholder="ZIP Code"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
          <input
            type="date"
            name="i9DOB"
            value={formData.i9DOB}
            onChange={handleInputChange}
            placeholder="Date of Birth"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
          />
          <input
            name="i9SSN"
            value={formData.i9SSN}
            onChange={handleInputChange}
            placeholder="U.S. Social Security Number (optional)"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
          />
          <input
            name="i9Email"
            value={formData.i9Email}
            onChange={handleInputChange}
            placeholder="Email Address"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
          />
          <input
            name="i9Phone"
            value={formData.i9Phone}
            onChange={handleInputChange}
            placeholder="Telephone Number"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Attestation Section */}
        <div className="mt-8 pt-6 border-t">
          <h4 className="font-semibold text-gray-800 mb-3">Attestation — Check One</h4>
          <div className="space-y-2">
            {[
              "1. A citizen of the United States",
              "2. A noncitizen national of the United States",
              "3. A lawful permanent resident (Alien Registration Number/USCIS Number: _______________)",
              "4. An alien authorized to work until (date below)",
            ].map((opt, i) => (
              <label key={i} className="flex items-start gap-2">
                <input
                  type="radio"
                  name="i9CitizenStatus"
                  value={opt}
                  checked={formData.i9CitizenStatus === opt}
                  onChange={handleInputChange}
                  className="w-4 h-4 text-blue-600 focus:ring-blue-500 mt-1"
                />
                <span className="text-gray-700">{opt}</span>
              </label>
            ))}
          </div>

          {formData.i9CitizenStatus?.includes("alien authorized") && (
            <div className="mt-4 space-y-3 ml-6">
              <input
                type="date"
                name="i9WorkAuthExpiration"
                value={formData.i9WorkAuthExpiration}
                onChange={handleInputChange}
                placeholder="Work Authorization Expiration Date"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
              />
              <input
                name="i9AlienNumber"
                value={formData.i9AlienNumber}
                onChange={handleInputChange}
                placeholder="Alien Registration Number/USCIS Number"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
              />
              <input
                name="i9AdmissionNumber"
                value={formData.i9AdmissionNumber}
                onChange={handleInputChange}
                placeholder="Form I-94 Admission Number"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
              />
              <input
                name="i9ForeignPassportNumber"
                value={formData.i9ForeignPassportNumber}
                onChange={handleInputChange}
                placeholder="Foreign Passport Number"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
              />
              <input
                name="i9CountryOfIssuance"
                value={formData.i9CountryOfIssuance}
                onChange={handleInputChange}
                placeholder="Country of Issuance"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
              />
            </div>
          )}
        </div>

        {/* Employee Signature */}
        <div className="mt-8 pt-6 border-t">
          <h4 className="font-semibold text-gray-800 mb-3">Signature of Employee</h4>
          <p className="text-sm text-gray-600 mb-3">
            I am aware that federal law provides for imprisonment and/or fines for false statements, or the use of false documents, in connection with the completion of this form.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {formData.applicantSignature && (
              <div className="flex flex-col">
                <img
                  src={formData.applicantSignature}
                  alt="Applicant Signature"
                  className="max-h-16 max-w-full object-contain mb-2 border p-2 rounded"
                />
                <span className="text-sm text-gray-600">Signature on file</span>
              </div>
            )}
            <input
              type="date"
              name="i9Date"
              value={formData.i9Date}
              onChange={handleInputChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
              placeholder="Date (mm/dd/yyyy)"
            />
          </div>
        </div>
      </div>

      {/* ========== SECTION 2 - EMPLOYER REVIEW ========== */}
      <div className="border-b pb-6 mb-6">
        <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
          <span className="bg-blue-600 text-white w-6 h-6 rounded-full flex items-center justify-center text-sm">2</span>
          Employer or Authorized Representative Review
        </h3>
        <p className="text-sm text-gray-600 mb-4">
          Employers must examine one document from List A OR a combination of one document from List B and one document from List C.
        </p>

        {/* Document Selection */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* List A */}
          <div className="border rounded-lg p-4 bg-gray-50">
            <h4 className="font-semibold text-gray-800 mb-3">List A — Identity & Employment Authorization</h4>
            <div className="space-y-2">
              {[
                "U.S. Passport or U.S. Passport Card",
                "Permanent Resident Card or Alien Registration Receipt Card",
                "Foreign passport with Form I-94",
                "Employment Authorization Document (EAD)",
                "Driver's license with photo"
              ].map((doc, i) => (
                <label key={i} className="flex items-center gap-2">
                  <input
                    type="radio"
                    name="i9ListADocument"
                    value={doc}
                    checked={formData.i9ListADocument === doc}
                    onChange={handleInputChange}
                    className="w-4 h-4 text-blue-600"
                  />
                  <span className="text-sm text-gray-700">{doc}</span>
                </label>
              ))}
            </div>
            {formData.i9ListADocument && (
              <div className="mt-3 space-y-2">
                <input
                  name="i9ListADocumentNumber"
                  value={formData.i9ListADocumentNumber}
                  onChange={handleInputChange}
                  placeholder="Document Number"
                  className="w-full px-3 py-2 border rounded-lg text-sm"
                />
                <input
                  name="i9ListAExpirationDate"
                  type="date"
                  value={formData.i9ListAExpirationDate}
                  onChange={handleInputChange}
                  placeholder="Expiration Date"
                  className="w-full px-3 py-2 border rounded-lg text-sm"
                />
              </div>
            )}
          </div>

          {/* List B + List C */}
          <div className="space-y-4">
            {/* List B */}
            <div className="border rounded-lg p-4 bg-gray-50">
              <h4 className="font-semibold text-gray-800 mb-3">List B — Identity</h4>
              <div className="space-y-2">
                {[
                  "Driver's license issued by a U.S. state",
                  "State-issued ID card",
                  "School ID with photo",
                  "Voter's registration card",
                  "U.S. Military card"
                ].map((doc, i) => (
                  <label key={i} className="flex items-center gap-2">
                    <input
                      type="radio"
                      name="i9ListBDocument"
                      value={doc}
                      checked={formData.i9ListBDocument === doc}
                      onChange={handleInputChange}
                      className="w-4 h-4 text-blue-600"
                    />
                    <span className="text-sm text-gray-700">{doc}</span>
                  </label>
                ))}
              </div>
              {formData.i9ListBDocument && (
                <div className="mt-3">
                  <input
                    name="i9ListBDocumentNumber"
                    value={formData.i9ListBDocumentNumber}
                    onChange={handleInputChange}
                    placeholder="Document Number"
                    className="w-full px-3 py-2 border rounded-lg text-sm"
                  />
                </div>
              )}
            </div>

            {/* List C */}
            <div className="border rounded-lg p-4 bg-gray-50">
              <h4 className="font-semibold text-gray-800 mb-3">List C — Employment Authorization</h4>
              <div className="space-y-2">
                {[
                  "Social Security Account Number card",
                  "Birth certificate",
                  "Employment Authorization Document",
                  "Native American tribal document",
                  "U.S. Citizen ID card"
                ].map((doc, i) => (
                  <label key={i} className="flex items-center gap-2">
                    <input
                      type="radio"
                      name="i9ListCDocument"
                      value={doc}
                      checked={formData.i9ListCDocument === doc}
                      onChange={handleInputChange}
                      className="w-4 h-4 text-blue-600"
                    />
                    <span className="text-sm text-gray-700">{doc}</span>
                  </label>
                ))}
              </div>
              {formData.i9ListCDocument && (
                <div className="mt-3">
                  <input
                    name="i9ListCDocumentNumber"
                    value={formData.i9ListCDocumentNumber}
                    onChange={handleInputChange}
                    placeholder="Document Number"
                    className="w-full px-3 py-2 border rounded-lg text-sm"
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Alternative Procedure (Remote Verification) */}
        <div className="mt-6">
          <label className="flex items-start gap-3 p-4 bg-blue-50 rounded-lg border border-blue-200">
            <input
              type="checkbox"
              name="i9AlternativeProcedure"
              checked={formData.i9AlternativeProcedure}
              onChange={handleInputChange}
              className="w-5 h-5 text-blue-600 mt-0.5"
            />
            <div>
              <span className="font-medium text-blue-800">Check here if you used an alternative procedure authorized by DHS to examine documents.</span>
              <p className="text-sm text-blue-600 mt-1">(Remote document examination under DHS authorization)</p>
            </div>
          </label>
        </div>

        {/* Employer Certification */}
        <div className="mt-6 p-4 bg-gray-50 rounded-lg border">
          <h4 className="font-semibold text-gray-800 mb-2">Certification</h4>
          <p className="text-sm text-gray-600 mb-3">
            I attest, under penalty of perjury, that (1) I have examined the documentation presented by the above-named employee, 
            (2) the above-listed documentation appears to be genuine and to relate to the employee named, and (3) to the best of my knowledge, 
            the employee is authorized to work in the United States.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Employer Business/Organization Name</label>
              <input
                name="i9EmployerName"
                value={formData.i9EmployerName}
                onChange={handleInputChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg"
                placeholder="SAMAH Home Health Care"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Employer Address</label>
              <input
                name="i9EmployerAddress"
                value={formData.i9EmployerAddress}
                onChange={handleInputChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg"
                placeholder="City, State, ZIP Code"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">First Day of Employment</label>
              <input
                type="date"
                name="i9FirstDayOfEmployment"
                value={formData.i9FirstDayOfEmployment}
                onChange={handleInputChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Today's Date</label>
              <input
                type="date"
                name="i9EmployerDate"
                value={formData.i9EmployerDate}
                onChange={handleInputChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg"
              />
            </div>
          </div>
          
          {/* Employer Signature */}
          <div className="mt-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Signature of Employer or Authorized Representative</label>
            {formData.hrSignature ? (
              <div className="flex flex-col">
                <img
                  src={formData.hrSignature}
                  alt="Employer Signature"
                  className="max-h-16 max-w-full object-contain mb-2 border p-2 rounded"
                />
                <span className="text-sm text-gray-600">Signature on file</span>
              </div>
            ) : (
              <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center text-gray-500">
                HR Signature Optional - To be completed by employer if available
              </div>
            )}
            <input
              name="i9EmployerTitle"
              value={formData.i9EmployerTitle}
              onChange={handleInputChange}
              placeholder="Title of Employer or Authorized Representative"
              className="w-full mt-3 px-4 py-3 border border-gray-300 rounded-lg"
            />
          </div>
        </div>
      </div>

      {/* Section 3 - Reverification (if applicable) */}
      <div>
        <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
          <span className="bg-blue-600 text-white w-6 h-6 rounded-full flex items-center justify-center text-sm">3</span>
          Reverification and Rehire (if applicable)
        </h3>
        <div className="p-4 bg-gray-50 rounded-lg border">
          <p className="text-sm text-gray-600 mb-3">
            Complete this section if the employee's work authorization has expired or if rehiring within 3 years of original I-9.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">New Work Authorization Expiration Date</label>
              <input
                type="date"
                name="i9NewExpirationDate"
                value={formData.i9NewExpirationDate}
                onChange={handleInputChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Document Title</label>
              <input
                name="i9ReverifyDocumentTitle"
                value={formData.i9ReverifyDocumentTitle}
                onChange={handleInputChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Document Number</label>
              <input
                name="i9ReverifyDocumentNumber"
                value={formData.i9ReverifyDocumentNumber}
                onChange={handleInputChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Signature of Employer/Rep</label>
              <input
                name="i9ReverifySignature"
                value={formData.i9ReverifySignature}
                onChange={handleInputChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg"
                placeholder="Full Name"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Date of Reverification</label>
              <input
                type="date"
                name="i9ReverifyDate"
                value={formData.i9ReverifyDate}
                onChange={handleInputChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);
  // Flyte Form

  const renderFlyteMECForm = () => (
    <div className="space-y-8">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-6 rounded-xl border border-blue-100">
        <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-3">
          <FaHeartbeat className="text-blue-600" />
          Flyte MEC Plan Participation Agreement
        </h2>
        <p className="text-gray-600 mt-2">
          Minimum Essential Coverage (MEC) Plan Enrollment — Complete this form
          to communicate your participation, eligibility, and covered
          individuals.
        </p>
      </div>

      {/* Member Information */}
      <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm space-y-6">
        <h3 className="text-lg font-semibold text-gray-800">
          Member Information
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <input
            name="flyteFirstName"
            value={formData.flyteFirstName}
            onChange={handleInputChange}
            placeholder="First Name"
            className="border p-3 rounded-lg w-full"
          />
          <input
            name="flyteMiddleInitial"
            value={formData.flyteMiddleInitial}
            onChange={handleInputChange}
            placeholder="MI"
            className="border p-3 rounded-lg w-full"
            maxLength={1}
          />
          <input
            name="flyteLastName"
            value={formData.flyteLastName}
            onChange={handleInputChange}
            placeholder="Last Name"
            className="border p-3 rounded-lg w-full"
          />
          <input
            name="flyteSSN"
            value={formData.flyteSSN}
            onChange={handleInputChange}
            placeholder="Social Security Number (required)"
            className="border p-3 rounded-lg w-full"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <input
            name="flyteAddress"
            value={formData.flyteAddress}
            onChange={handleInputChange}
            placeholder="Mailing Address"
            className="border p-3 rounded-lg w-full"
          />
          <input
            name="flyteCity"
            value={formData.flyteCity}
            onChange={handleInputChange}
            placeholder="City"
            className="border p-3 rounded-lg w-full"
          />
          <input
            name="flyteState"
            value={formData.flyteState}
            onChange={handleInputChange}
            placeholder="State"
            className="border p-3 rounded-lg w-full"
          />
          <input
            name="flyteZip"
            value={formData.flyteZip}
            onChange={handleInputChange}
            placeholder="ZIP Code"
            className="border p-3 rounded-lg w-full"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <input
            name="flyteCompanyName"
            value={formData.flyteCompanyName}
            onChange={handleInputChange}
            placeholder="Company Name"
            className="border p-3 rounded-lg w-full"
          />
          <input
            name="flyteMemberEmail"
            value={formData.flyteMemberEmail}
            onChange={handleInputChange}
            placeholder="Member Email Address"
            className="border p-3 rounded-lg w-full"
          />
          <div className="flex items-center gap-4">
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="flyteCoverageLevel"
                value="Single"
                checked={formData.flyteCoverageLevel === "Single"}
                onChange={handleInputChange}
              />
              Single
            </label>
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="flyteCoverageLevel"
                value="Family"
                checked={formData.flyteCoverageLevel === "Family"}
                onChange={handleInputChange}
              />
              Family
            </label>
          </div>
        </div>
      </div>

      {/* Type of Enrollment */}
      <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm space-y-6">
        <h3 className="text-lg font-semibold text-gray-800">
          Type of Enrollment
        </h3>
        <div className="flex flex-wrap gap-6">
          {[
            "New Hire",
            "Plan Open Enrollment",
            "Qualified Status Change Event",
          ].map((type) => (
            <label key={type} className="flex items-center gap-2">
              <input
                type="radio"
                name="flyteEnrollmentType"
                value={type}
                checked={formData.flyteEnrollmentType === type}
                onChange={handleInputChange}
              />
              {type}
            </label>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
          <div className="span">
            <p>Hire date</p>

            <input
              type="date"
              name="flyteHireDate"
              value={formData.flyteHireDate}
              onChange={handleInputChange}
              className="border p-3 rounded-lg w-full"
              placeholder="Hire Date"
            />
          </div>
          <div className="span">
            <p>Effective Date</p>

            <input
              type="date"
              name="flyteEffectiveDate"
              value={formData.flyteEffectiveDate}
              onChange={handleInputChange}
              className="border p-3 rounded-lg w-full"
              placeholder="Effective Date"
            />
          </div>
        </div>
      </div>

      {/* Covered Individuals */}
      <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">
          Covered Individuals
        </h3>
        <p className="text-gray-600 mb-4 text-sm">
          List all eligible family members (including yourself) you wish to
          enroll in the MEC plan.
        </p>

        {[...Array(4)].map((_, i) => (
          <div
            key={i}
            className="grid grid-cols-1 md:grid-cols-6 gap-4 mb-4 border-b pb-4"
          >
            <input
              name={`flyteCoveredName${i}`}
              value={formData[`flyteCoveredName${i}`] || ""}
              onChange={handleInputChange}
              placeholder="Name (Last, First, MI)"
              className="border p-2 rounded-md"
            />
            <input
              name={`flyteCoveredSSN${i}`}
              value={formData[`flyteCoveredSSN${i}`] || ""}
              onChange={handleInputChange}
              placeholder="SSN"
              className="border p-2 rounded-md"
            />
            <input
              type="date"
              name={`flyteCoveredDOB${i}`}
              value={formData[`flyteCoveredDOB${i}`] || ""}
              onChange={handleInputChange}
              className="border p-2 rounded-md"
            />
            <select
              name={`flyteCoveredGender${i}`}
              value={formData[`flyteCoveredGender${i}`] || ""}
              onChange={handleInputChange}
              className="border p-2 rounded-md"
            >
              <option value="">Gender</option>
              <option value="M">M</option>
              <option value="F">F</option>
            </select>
            <select
              name={`flyteCoveredRelationship${i}`}
              value={formData[`flyteCoveredRelationship${i}`] || ""}
              onChange={handleInputChange}
              className="border p-2 rounded-md"
            >
              <option value="">Relationship</option>
              <option value="Self">Self</option>
              <option value="Dependent Child">Dependent Child</option>
              <option value="Spouse">Spouse</option>
            </select>
            <input
              name={`flyteCoveredCarrier${i}`}
              value={formData[`flyteCoveredCarrier${i}`] || ""}
              onChange={handleInputChange}
              placeholder="Primary Insurance Carrier"
              className="border p-2 rounded-md"
            />
          </div>
        ))}
      </div>

      {/* Participation Waiver */}
      <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">
          Participation Waiver
        </h3>
        <label className="flex items-start gap-3">
          <input
            type="checkbox"
            name="flyteWaiver"
            checked={formData.flyteWaiver}
            onChange={handleInputChange}
            className="w-5 h-5 text-blue-600"
          />
          <span className="text-gray-700">
            I do <strong>NOT</strong> wish to participate in this tax-free,
            employer-sponsored plan.
          </span>
        </label>
      </div>

      {/* Certification */}
      <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm space-y-4">
        <h3 className="text-lg font-semibold text-gray-800">
          Certification & Acknowledgment
        </h3>
        <p className="text-gray-700 text-sm">
          I understand that my coverage can only be changed during the open
          enrollment period of the MEC or if I have a Qualified Change affecting
          my eligibility or the eligibility of my covered family members. I was
          offered the ability to opt out of the plan and have checked the box
          above if I chose to do so.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-2 border-t">
          {formData.applicantSignature && (
            <div className="flex flex-col items-center">
              <img
                src={formData.applicantSignature}
                alt="Applicant Signature"
                className="max-h-20 max-w-full object-contain mb-2"
              />
              <span className="text-sm text-gray-600">Applicant Signs</span>
            </div>
          )}
          {formData.hrSignature && (
            <div className="flex flex-col items-center">
              <img
                src={formData.hrSignature}
                alt="Applicant Signature"
                className="max-h-20 max-w-full object-contain mb-2"
              />
              <span className="text-sm text-gray-600">Hr Signature</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  const renderStepContent = () => {
    switch (currentStep) {
      case 0:
        return renderCoverSheet();
      case 1:
        return renderEmploymentApplication();
      case 2:
        return renderAvailability();
      case 3:
        return renderReferences();
      case 4:
        return renderEmploymentHistory();
      case 5:
        return renderBackgroundCheck();
      case 6:
        return renderDirectDeposit();
      case 7:
        return renderJobDescription();
      case 8:
        return renderSignatures();
      case 9:
        return renderW4Form();
      case 10:
        return renderI9Form();
      case 11:
        return renderFlyteMECForm();
      case 12:
        return renderReview();
      default:
        return renderCoverSheet();
    }
  };

  const StepIcon = steps[currentStep].icon;

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50 py-8 px-4 pt-5">
      <div className="max-w-6xl mx-auto mt-5 pt-5">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          {/* Header */}
          <div className="bg-[#0096fa] text-white px-8 py-6">
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
              <div>
                <h1 className="text-3xl font-bold">SAMAH HOME HEALTH CARE</h1>
                <p className="text-blue-100 text-lg mt-2">
                  PCA Complete Application Form
                </p>
              </div>
              <div className="mt-4 lg:mt-0 text-right">
                <div className="text-blue-200 text-sm">Step</div>
                <div className="text-2xl font-semibold">
                  {currentStep + 1} <span className="text-blue-200">/</span>{" "}
                  {steps.length}
                </div>
              </div>
            </div>
          </div>

          {/* Progress Bar */}
          <div className="px-8 pt-6">
            <div className="w-full bg-gray-200 rounded-full h-2">
              <div
                className="bg-green-500 h-2 rounded-full transition-all duration-500 ease-out"
                style={{
                  width: `${((currentStep + 1) / steps.length) * 100}%`,
                }}
              ></div>
            </div>
          </div>

          {/* Message Alerts */}
          <div className="px-8 pt-6">
            {message && (
              <div className="mb-6 p-4 bg-yellow-50 border-l-4 border-yellow-400 rounded-r-lg">
                <div className="flex">
                  <div className="flex-shrink-0">
                    <svg
                      className="h-5 w-5 text-yellow-400"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <div className="ml-3">
                    <p className="text-sm text-yellow-700">{message}</p>
                  </div>
                </div>
              </div>
            )}
            {saved && (
              <div className="mb-6 p-4 bg-green-50 border-l-4 border-green-400 rounded-r-lg">
                <div className="flex">
                  <div className="flex-shrink-0">
                    <FaRegCheckCircle className="h-5 w-5 text-green-400" />
                  </div>
                  <div className="ml-3">
                    <p className="text-sm text-green-700">
                      Application submitted successfully!
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Step Indicator */}
          <div className="px-8 py-6 border-b">
            <div className="flex items-center space-x-4 overflow-x-auto pb-2">
              {steps.map((step, idx) => {
                const Icon = step.icon;
                return (
                  <div
                    key={step.name}
                    className="flex items-center space-x-3 flex-shrink-0"
                  >
                    <div
                      className={`flex items-center justify-center w-10 h-10 rounded-full transition-all duration-300 ${idx === currentStep
                          ? "bg-blue-600 text-white shadow-lg shadow-blue-200"
                          : idx < currentStep
                            ? "bg-green-500 text-white"
                            : "bg-gray-200 text-gray-500"
                        }`}
                    >
                      {idx < currentStep ? (
                        <FaRegCheckCircle size={16} />
                      ) : (
                        <Icon size={16} />
                      )}
                    </div>
                    <span
                      className={`text-sm font-medium hidden md:block ${idx === currentStep
                          ? "text-blue-600"
                          : idx < currentStep
                            ? "text-green-600"
                            : "text-gray-500"
                        }`}
                    >
                      {step.name}
                    </span>
                    {idx < steps.length - 1 && (
                      <div
                        className={`w-8 h-0.5 ${idx < currentStep ? "bg-green-500" : "bg-gray-300"
                          }`}
                      />
                    )}
                  </div>
                );
              })}
            </div>
          </div>

          {/* Form Content */}
          <div className="p-8">
            <form onSubmit={handleSubmit}>
              <div className="mb-8">{renderStepContent()}</div>

              {currentStep === steps.length - 1 && (
                <section className="mb-8 rounded-xl border border-blue-100 bg-blue-50/60 p-6" aria-labelledby="training-resources-heading">
                  <div className="mb-4">
                    <h3 id="training-resources-heading" className="text-lg font-semibold text-gray-800">
                      Caregiver Training Resources
                    </h3>
                    <p className="mt-1 text-sm text-gray-600">
                      Please review these training resources before submitting your application.
                    </p>
                  </div>
                  <ul className="grid grid-cols-1 gap-3 md:grid-cols-2">
                    {[
                      { label: "HIPAA", url: "https://www.youtube.com/watch?v=CRQwUIXMoqM" },
                      { label: "Blood Borne Pathogens", url: "https://www.youtube.com/watch?v=ifE4eppO5ak" },
                      { label: "Body Mechanics (safe lifting)", url: "https://www.youtube.com/watch?v=2fcWRulrhwg" },
                      { label: "Caregiver Training", url: "https://training.mmlearn.org/caregiver-training-videos/topic/assistive-devices" },
                      { label: "Bedding Occupied", url: "https://www.youtube.com/watch?v=AN9pvC499P4" },
                      { label: "Mobility", url: "https://www.youtube.com/watch?v=-dpSup2Tcas" },
                      { label: "Bath and Shower", url: "https://www.youtube.com/watch?v=ffCd7cxFAPk" },
                    ].map(({ label, url }) => (
                      <li key={label}>
                        <a
                          href={url}
                          target="_blank"
                          rel="noreferrer"
                          className="group flex min-h-12 items-center justify-between rounded-lg border border-blue-200 bg-white px-4 py-3 text-sm font-medium text-blue-700 shadow-sm outline-none transition-all duration-300 ease-out hover:-translate-y-1 hover:border-blue-400 hover:bg-blue-50 hover:text-blue-900 hover:shadow-lg focus:-translate-y-1 focus:border-blue-400 focus:bg-blue-50 focus:text-blue-900 focus:shadow-lg"
                        >
                          <span>{label}</span>
                          <FaArrowRight
                            aria-hidden="true"
                            className="ml-3 shrink-0 transition-transform duration-300 ease-out group-hover:translate-x-1 group-focus:translate-x-1"
                          />
                        </a>
                      </li>
                    ))}
                  </ul>
                </section>
              )}

              {/* Navigation Buttons */}
              <div className="flex justify-between items-center pt-6 border-t">
                <button
                  type="button"
                  onClick={prevStep}
                  disabled={currentStep === 0}
                  className="flex items-center gap-3 px-6 py-3 bg-white border border-gray-300 rounded-xl text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
                >
                  <FaArrowLeft />
                  Previous
                </button>

                {currentStep < steps.length - 1 ? (
                  <button
                    type="button"
                    onClick={handleNext}
                    className="flex items-center gap-3 px-6 py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition-all duration-200 shadow-lg shadow-blue-200"
                  >
                    Next Step
                    <FaArrowRight />
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="flex items-center gap-3 px-8 py-3 bg-green-600 text-white rounded-xl hover:bg-green-700 transition-all duration-200 shadow-lg shadow-green-200"
                  >
                    {loading ? <FaSpinner className="animate-spin" /> : <CircleCheck />}
                    {loading ? "Submitting..." : "Submit Application"}
                  </button>
                )}
              </div>
            </form>
          </div>

          {/* Footer */}
          <div className="bg-gray-50 px-8 py-4 border-t">
            <p className="text-xs text-gray-500 text-center">
              Note: This is a digital application form. All information will be
              securely processed and stored. SAMAH Home Health Care is an equal
              opportunity employer.
            </p>
            
          </div>
        </div>
      </div>
    </div>
  );
}
